import { createIcon } from '@chakra-ui/icons';

export const Star = createIcon({
  displayName: 'Star',
  viewBox: '0 0 24 24',
  d: 'M19.4087 24L12 19.1606L4.5913 24L6.67826 15.0847L0 9.14931L8.71884 8.48435L12 0L15.2812 8.48435L24 9.14931L17.3217 15.0847L19.4087 24ZM12 16.8456L16.5101 19.7886L15.2464 14.3581L19.2928 10.7748L14.0058 10.3684L12 5.1842L9.9942 10.3684L4.70725 10.7748L8.75362 14.3581L7.48986 19.7886L12 16.8456Z',
});
